export class NewslettersCreate {

    public subject: string;
    public body: string;
    public test: boolean;
    public target: string;

    constructor() {}
}
